<template>
  <v-container fluid>
    <v-row align="center" justify="space-around">
      <v-row align="center" justify="space-around" style="display: contents;">
        <template v-for="(item, index) in ItemsDashboard2">
          <v-col
            cols="12"
            lg="2"
            md="4"
            sm="6"
            xs="12"
            style="text-align: initial; line-height: normal;min-width: 130px;"
            v-bind:key="index"
          >
            <v-card
              height="135px"
              style="display: grid;"
              v-if="viewSkeletons"
              :color="whitesmoke"
            >
              <v-col cols="12">
                <div :class="skeleton" :style="backgroundSkeleton"></div>
              </v-col>
              <v-col cols="12">
                <div :class="skeleton" :style="backgroundSkeleton"></div>
              </v-col>
            </v-card>
            <v-card
              height="135px"
              style="display: grid;"
              v-else
              :color="whitesmoke"
            >
              <v-row style="display: contents;">
                <v-divider
                  light
                  vertical
                  :color="colorTheme"
                  style="position: absolute;border-width: 2px;"
                ></v-divider>
                <v-col cols="12">
                  <div class="headline" style="font-size: 13px !important;">
                    {{ item.title }}
                  </div>
                </v-col>
                <v-col cols="12">
                  <div
                    class="font-weight-medium my-2 headline;"
                    style="font-size: xx-large;"
                  >
                    {{ item.value }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </template>
      </v-row>
      <template v-for="(item, index) in itemsBalanceCharts">
        <v-col
          xs="12"
          sm="12"
          lg="3"
          md="4"
          cols="12"
          v-if="item.value == 1"
          v-bind:key="index"
        >
          <v-card v-if="viewSkeletons" :color="whitesmoke">
            <v-col cols="12">
              <div :class="skeletonTitle" :style="backgroundSkeleton"></div>
            </v-col>
            <v-col cols="12">
              <div :class="skeletonColumn" :style="backgroundSkeleton"></div>
            </v-col>
          </v-card>
          <v-card :color="whitesmoke">
            <highcharts :id="item.title"></highcharts>
          </v-card>
        </v-col>

        <v-col
          xs="12"
          sm="12"
          lg="9"
          md="8"
          cols="12"
          v-else
          v-bind:key="index"
        >
          <v-card v-if="viewSkeletons" :color="whitesmoke">
            <v-col cols="12">
              <div :class="skeletonTitle" :style="backgroundSkeleton"></div>
            </v-col>
            <v-col cols="12">
              <div :class="skeletonColumn" :style="backgroundSkeleton"></div>
            </v-col>
          </v-card>
          <v-card :color="whitesmoke">
            <highcharts :id="item.title"></highcharts>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/plugins/i18n";
export default {
  name: "accountBalancePage",
  data() {
    return {
      ItemsDashboard2: [],
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("setPageHeader", [
      this.$t("titleABalance"),
      "",
      "",
      "",
      true,
    ]);
    //this.$store.commit("skeleton", "outskeleton");
    //this.$store.commit("skeletonTitle", "outskeletonTitle");
    //this.$store.commit("skeletonColumn", "outskeletonColumn");

    //Dashboard account
    var vehiclesList = JSON.parse(localStorage.getItem("v_list"));
    var vehicles = vehiclesList == undefined ? 150 : vehiclesList.length;
    this.ItemsDashboard2 = [
      {
        title: this.$t("vehiclesD"),
        value: vehicles,
      },
      {
        title: this.$t("totalFuel"),
        value: "500 " + this.$store.state.SelectedVolume,
      },
      {
        title: this.$t("ralentifuel"),
        value: "26 " + this.$store.state.SelectedVolume,
      },
      {
        title: this.$t("exceptionsHome"),
        value: "8,905",
      },
      {
        title: this.$t("totalDistance"),
        value: "709.564 " + this.$store.state.SelectedDistance,
      },
      {
        title: this.$t("totalPerformance"),
        value:
          "1.66 " +
          this.$store.state.SelectedDistance +
          "/" +
          this.$store.state.SelectedVolume,
      },
    ];
  },
  computed: {
    ...mapState([
      "ItemsAccountBalancePage",
      "ItemsDashboard",
      "colorTheme",
      "itemsBalanceCharts",
      "viewSkeletons",
      "backgroundSkeleton",
    ]),
    skeleton: {
      get: function() {
        return this.$store.state.skeleton;
      },
      set: function() {},
    },
    skeletonTitle: {
      get: function() {
        return this.$store.state.skeletonTitle;
      },
      set: function() {},
    },
    skeletonColumn: {
      get: function() {
        return this.$store.state.skeletonColumn;
      },
      set: function() {},
    },
  },
  mounted() {
    //this.$store.commit("UnitSystemValues");
    this.$store.dispatch("getItemsDashboard", [false, false]);
    //this.$store.commit("backgroundSkeleton");
  },
};
</script>

<style scoped>
@import "./../assets/styles/skeletons.css";
</style>
